import React from "react";
import { useState } from "react";
import { Button } from "reactstrap";

export default function WishItem({ index, item, row, getAllWishLists, setAutoExpand, display, setDisplay }) {

  const [disableUpdateBtn, setDisableUpdateBtn] = useState(true);
  const [forUpdateInputValue, setForUpdateInputValue] = useState();
  const inputOnchangeHandle = (e) => {
    console.log(e.target.value);
    setForUpdateInputValue(e.target.value);
    if (e.target.value) {
      setDisableUpdateBtn(false);
    }
  };

  const handleWishUpdate = async (wishID, gId) => {
    //console.log('specificIem: ',specificDescryiptionToUpdate, 'WISHID: ', wishID)
    try {
      const response = await fetch(
        `api/v1/WatchHunter/wishes/${wishID}/wish/${gId}`,
        {
          method: "PUT",
          headers: new Headers({ "Content-Type": "application/json" }),
          body: JSON.stringify({
            Description: forUpdateInputValue,
          }),
        }
      );
      if (response.ok) {
        console.log(response);
        setAutoExpand(false);
        getAllWishLists();
        setForUpdateInputValue("");
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
      setDisableUpdateBtn(true);
    }
  };

  const handleDeleteSingleWish = async (wishID, gId) => {
    try {
      const response = await fetch(
        `/api/v1/WatchHunter/wishes/${wishID}/wish/${gId}`,
        {
          method: "DELETE",
        }
      );
      if (response.ok) {
        console.log(response);
        getAllWishLists();
        setAutoExpand(true)
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
    }
  };

  //const [secondLevelNested, setSecondLevelNested] = useState(null);
  const [displayAddWishInput, setDisplayAddWishInput] = useState(false);
  //const [idOfAddInput, setIdOfAddInput] = useState(undefined);
  //const [idOfSecondLevelNestied, setIdOfSecondLevelNestied] =
    useState(undefined);

  const handleAddBtnClick = (id) => {
    setDisplayAddWishInput((prevState) => !prevState);
    
  };

  const handleAddNewWish = async (e, wishId) => {
      //console.log('specificIem: ',specificDescryiptionToUpdate, 'WISHID: ', wishID)
      console.log(e.target.value, e)
      var wishdesc= e.target.value;
      try {
        const response = await fetch(
          `api/v1/WatchHunter/wishes/${wishId}/wish`,
          {
            method: "POST",
            headers: new Headers({ "Content-Type": "application/json" }),
            body: JSON.stringify(
              [
                  {
                      description: wishdesc
                  },
              ]
            ),
          }
        );
        if (response.ok) {
          console.log(response);
          getAllWishLists();
          setForUpdateInputValue("");
          setAutoExpand(false)
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (err) {
        console.error(err);
        // Handle errors here
      } finally {
        console.log("FINALLY");
        setDisableUpdateBtn(true);
      }
    
  } 
  return (
    <>
      <div
        className="ml-4 d-flex justify-content-between"
        //style={index === row.original.wishes.length - 1 ? { flexWrap: "wrap" } : {} }
      >
        {/*  <span
            style={{ cursor: 'pointer', alignSelf: 'center' }}
            onClick={() => { secondLevelNested === index ? setSecondLevelNested(undefined) : setSecondLevelNested(prevState => index); setIdOfSecondLevelNestied(row.original.id) }}
            id={index}
        >
            secondLevelNested === index && idOfSecondLevelNestied === row.original.id ? '➖' : '➕' 
        </span>*/}
        <input
          id="customerFormWishItem"
          className="customerFormEditableInput"
          //style={index === row.original.wishes.length - 1 ? { width: "88%" } : {}}
          defaultValue={item.description}
          //value={inputValue || item}
          onChange={(e) => {
            inputOnchangeHandle(e);
          }}
          type="search"
        />
        <Button
          size="sm"
          color="success"
          disabled={disableUpdateBtn}
          onClick={() => {
            handleWishUpdate(row.original._id, item.gid);
          }}
          className="mr-1"
        >
          Update
        </Button>
        <Button size="sm" color="danger" outline onClick={() => {
            handleDeleteSingleWish(row.original._id, item.gid);
          }}>
          Delete
        </Button>
        <Button size="sm" className="ml-1 d-none" color='success' outline onClick={()=>{setDisplay(true)}} style={{whiteSpace: 'nowrap'}}><b><span>N</span> Responses</b></Button>
        {/*index === row.original.wishes.length - 1 && (
          <Button
            onClick={() => {
              handleAddBtnClick(row.original.id);
            }}
            size="sm"
            color="primary"
            className="ml-2"
            outline
            style={{ whiteSpace: "nowrap" }}
          >
            Add
          </Button>
          )*/}
        {/*
          displayAddWishInput &&
           (
            <>
              <br />
              <input
                type="search"
                className=" mt-2"
                outline
                style={{ width: "100%" }}
                placeholder="New wish description"
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                      handleAddNewWish(event, row.original._id)
                  }
              }}
              ></input>
            </>
            )*/}
      </div>
      {row.original.wishes.length - 1 === index &&
      <input
                type="search"
                className=" mt-2"
                outline
                style={{ width: "100%" }}
                placeholder="  For adding more wish in this list, just write it here and then press enter"
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                      handleAddNewWish(event, row.original._id)
                  }
              }}
              ></input>
            }
    </>
  );
}
